import {
  IconTab1,
  IconTab2,
  IconTab3,
  IconTab4,
  IconTab5,
} from '@/components/home/icons';
import { tabDiagrams } from '@/components/home/FeatureTabDiagrams';
import { ReactElement } from 'react';

interface ITab {
  heading: string;
  bullets: string[];
  label: string;
  bgDecoration?: boolean;
  Icon: () => ReactElement;
  description?: string;
  Diagram?: () => ReactElement;
}

const tabs: ITab[] = [

  {
    label: 'Policy Engine',
    Icon: IconTab5,
    heading: 'Permissions that enforce themselves.',
    bullets: [
      'Eliminate access sprawl with ABAC policy enforcement that automatically governs who can access what, under what conditions, and what they can do',
      'Continuous authorization means permissions update the moment identity, behavior, or risk changes, closing the gap before it becomes a vulnerability',
      'Walk into any audit with every policy decision already logged, timestamped, and ready',
    ],
    Diagram: tabDiagrams['Policy Engine'],
  },
  {
    label: 'AI Governance',
    Icon: IconTab3,
    heading: 'Your AI agents are making decisions. Make sure they\'re the right ones.',
    bullets: [
      'Surface and govern shadow AI activity before ungoverned agent access becomes a data exposure event',
      'Enforce precise boundaries on what AI agents can access, process, and act on, keeping AI productive and your risk profile intact',
      'Every prompt, response, and tool call is logged and auditable, giving compliance teams the evidence they need for GenAI security reviews'
    ],
    Diagram: tabDiagrams['AI Governance'],
  },
  {
    label: 'Unified Identity Layer',
    Icon: IconTab2,
    heading: 'Identity verification that never clocks out.',
    bullets: [
      'Continuous identity verification evaluates every session in real time, catching compromised credentials and hijacked sessions before attackers can escalate',
      'One identity framework governs users, AI agents, services, and devices, eliminating the fragmentation gaps that attackers exploit',
      'When risk signals change, access is revoked immediately across every surface, with no lag and no manual intervention required'
    ],
    Diagram: tabDiagrams['Unified Identity Layer'],
  },

  {
    label: 'Secure Access',
    Icon: IconTab4,
    heading: 'Give everyone secure access without giving up control.',
    bullets: [
      'Enforce Zero Trust Network Access at the session layer, giving employees, contractors, and third parties precisely the access their role, device, and risk profile warrant',
      'Session-level DLP controls follow users across every device and location, keeping sensitive data where it belongs regardless of how or where someone is working',
      'Every access request is verified against current identity and risk in real time, so your security posture stays current automatically'
    ],
    Diagram: tabDiagrams['Secure Access'],
  },
  {
    label: 'SDK',
    Icon: IconTab1,
    heading: 'Build security in, not on.',
    bullets: [
      'Embed identity verification, policy enforcement, and Zero Trust access controls directly into your applications and architectures from day one',
      'Pre-built components for authentication, authorization, and governance let development teams move fast while keeping your security posture intact',
      'Extensible APIs support custom governance and access use cases across platforms and languages, so security scales as your product does',
    ],
    Diagram: tabDiagrams['SDK'],
  },
] as const;

export default tabs;
